// Ohio cities ClearView serves. Used by ServiceAreas section + dynamic city pages.
export const CITIES = [
  { slug: "akron", name: "Akron", county: "Summit", featured: true,
    blurb: "From historic neighborhoods in Highland Square to newer builds in West Akron, we keep Akron homes looking their best year-round.",
    zips: ["44301", "44302", "44303", "44304", "44305"] },
  { slug: "canton", name: "Canton", county: "Stark", featured: true,
    blurb: "Stark County's homeowners trust ClearView for soft-wash siding, driveway restoration, and gutter clean-outs that protect the home.",
    zips: ["44702", "44703", "44705", "44708", "44709"] },
  { slug: "cleveland", name: "Cleveland", county: "Cuyahoga", featured: true,
    blurb: "We serve Greater Cleveland — from Tremont brick to lake-effect mildew on the West Side. Honest pricing, careful crews.",
    zips: ["44102", "44109", "44113", "44114", "44115"] },
  { slug: "cuyahoga-falls", name: "Cuyahoga Falls", county: "Summit", featured: true,
    blurb: "Older homes near the Falls need a gentle, expert touch. Our soft-wash system protects siding while lifting algae and grime.",
    zips: ["44221", "44223"] },
  { slug: "stow", name: "Stow", county: "Summit", featured: true,
    blurb: "Stow neighborhoods love a clean driveway. We restore concrete, brick paver patios, and back decks across Stow & Munroe Falls.",
    zips: ["44224"] },
  { slug: "hudson", name: "Hudson", county: "Summit", featured: true,
    blurb: "Hudson's premium properties deserve premium care. We pressure-wash with surface cleaners that leave no streaks or wand marks.",
    zips: ["44236"] },
  { slug: "medina", name: "Medina", county: "Medina", featured: true,
    blurb: "From the historic square to newer subdivisions, Medina homeowners count on us for fast, fair, five-star pressure washing.",
    zips: ["44256"] },
  { slug: "wooster", name: "Wooster", county: "Wayne", featured: true,
    blurb: "We're proud to serve Wayne County. Soft-wash siding, gutter clean-outs, and driveway restoration done right the first time.",
    zips: ["44691"] },
  { slug: "massillon", name: "Massillon", county: "Stark", featured: true,
    blurb: "Tiger Town homes look better in white. Our soft-wash system lifts mildew without damaging vinyl, brick, or paint.",
    zips: ["44646", "44647"] },
  { slug: "barberton", name: "Barberton", county: "Summit", featured: true,
    blurb: "Magic City homeowners know us by name. Reliable, friendly, and the cleanest pressure washing in town.",
    zips: ["44203"] },
  { slug: "north-canton", name: "North Canton", county: "Stark", featured: true,
    blurb: "We restore curb appeal across North Canton — driveways, patios, and the full exterior of the home.",
    zips: ["44720"] },
  { slug: "tallmadge", name: "Tallmadge", county: "Summit", featured: true,
    blurb: "Quiet neighborhoods, careful crews. We treat every Tallmadge property like it's our own.",
    zips: ["44278"] },
  { slug: "green", name: "Green", county: "Summit", featured: false,
    blurb: "Modern subdivisions need a careful hand on stamped concrete and stained driveways. We deliver.",
    zips: ["44685"] },
  { slug: "fairlawn", name: "Fairlawn", county: "Summit", featured: false,
    blurb: "Fairlawn homes shine after a ClearView visit. Insured, on-time, and built around the customer.",
    zips: ["44333"] },
  { slug: "bath", name: "Bath", county: "Summit", featured: false,
    blurb: "Bath Township's larger lots and longer driveways are no problem — we have the right rig for every job.",
    zips: ["44210"] },
];

export const CITIES_BY_SLUG = Object.fromEntries(CITIES.map((c) => [c.slug, c]));
